import { AccountInterface, Call, Contract, RpcProvider } from 'starknet';
import { Decimal } from '../../datastructures';
import { getConfigManager } from '../../config';
import StakeABI from './abi/Stake_abi.json';
import { executeTransaction } from '../../utils';
import { InvokeResponse } from '../../interfaces';

export class StakeContract {
  private contract: Contract;
  private runner: AccountInterface | null;
  private provider: RpcProvider;

  constructor(provider: RpcProvider, runner?: AccountInterface) {
    this.contract = new Contract({ abi: StakeABI, address: getConfigManager().getConfig().nstSTRK, providerOrAccount: provider });
    this.runner = runner || null;
    this.provider = provider;
  }

  async deposit(amount: Decimal): Promise<InvokeResponse> {
    if (!this.runner) {
      throw new Error('StakeContract -> deposit() -> Runner not set');
    }

    const config = getConfigManager().getConfig();

    const amountUint256 = amount.toUint256(config.assets.STRK.tokenPrecision);

    const calls: Call[] = [
      {
        contractAddress: config.assets.STRK.address,
        entrypoint: 'approve',
        calldata: [config.nstSTRK, amountUint256.low, amountUint256.high],
      },
      {
        contractAddress: config.nstSTRK,
        entrypoint: 'deposit',
        calldata: [amountUint256.low, amountUint256.high, this.runner.address],
      },
    ];

    return executeTransaction(this.runner, calls);
  }

  async redeem(amount: Decimal): Promise<InvokeResponse> {
    if (!this.runner) {
      throw new Error('StakeContract -> withdraw() -> Runner not set');
    }

    const config = getConfigManager().getConfig();

    const amountUint256 = amount.toUint256(config.assets.STRK.tokenPrecision);

    const calls: Call[] = [
      {
        contractAddress: config.nstSTRK,
        entrypoint: 'redeem',
        calldata: [amountUint256.low, amountUint256.high, this.runner.address, this.runner.address],
      },
    ];

    return executeTransaction(this.runner, calls);
  }

  async depositCap(): Promise<Decimal> {
    const result = await this.contract.deposit_cap();

    return new Decimal(result, getConfigManager().getConfig().assets.STRK.tokenPrecision);
  }

  async totalAssets(): Promise<Decimal> {
    const result = await this.contract.total_assets();

    return new Decimal(result, getConfigManager().getConfig().assets.STRK.tokenPrecision);
  }

  async withdrawalFee(): Promise<Decimal> {
    const result = await this.contract.withdrawal_fee();

    return new Decimal(result, getConfigManager().getConfig().assets.STRK.tokenPrecision);
  }
}
